export default __webpack_public_path__ + "static/media/ferramenta-reels-img9.b2e77649.jpeg";